module.exports = __webpack_public_path__ + "static/img/template_img_07.79a7489f.jpg";